class PermissionDeniedException extends Error {
    constructor(message) {
        super(message || "Permission denied.")
    }
}

export default PermissionDeniedException
